import * as L from 'leaflet';
import { addClassNames } from './lib/utils/dom';
import { TIME_PLAYBACK_STARTED_RESUMED, TIME_PLAYBACK_ENDED, TIME_PLAYBACK_PAUSED, RESET_TIMESTEPS, } from './events';
/**
 * The playback control default options.
 */
const CONTROL_PLAYBACK_OPTIONS_DEFAULT = {
    position: 'bottomright',
};
/**
 * The playback control.
 */
export class ControlPlayback extends L.Control {
    /**
     * @param options - The playback control options.
     * @param maapInstance - The M.A.A.P. instance.
     */
    constructor(options, maapInstance) {
        super(Object.assign(Object.assign({}, CONTROL_PLAYBACK_OPTIONS_DEFAULT), options));
        this.maapInstance = maapInstance;
    }
    /**
     * The hook to execute when the control is added to the map.
     * @returns The container element to be added to the map.
     * @see {@link https://leafletjs.com/reference-1.7.1.html#control-extension-methods}
     */
    onAdd() {
        const container = L.DomUtil.create('div', 'maap_p-control-playback');
        addClassNames(container, [
            'maap_c-control',
            'maap_p-bottom-controls__control',
            'maap_p-bottom-controls__control--button',
        ]);
        L.DomEvent.disableClickPropagation(container);
        this._toggle = L.DomUtil.create('button', 'maap_p-control-playback__toggle', container);
        this._toggle.classList.add('maap_c-icon-container');
        L.DomEvent.on(this._toggle, 'click', this.onClick, this);
        const icon = L.DomUtil.create('span', 'maap_p-control-playback__icon', this._toggle);
        icon.classList.add('maap_c-icon-container__icon');
        this.maapInstance.on(`${TIME_PLAYBACK_STARTED_RESUMED} ${TIME_PLAYBACK_PAUSED} ` +
            `${TIME_PLAYBACK_ENDED} ${RESET_TIMESTEPS}`, this.update, this);
        return container;
    }
    /**
     * The hook to execute when the control is removed the map.
     * @see {@link https://leafletjs.com/reference-1.7.1.html#control-extension-methods}
     */
    onRemove() {
        if (this._toggle) {
            L.DomEvent.off(this._toggle, 'click', this.onClick, this);
        }
        this.maapInstance.time.off(`${TIME_PLAYBACK_STARTED_RESUMED} ${TIME_PLAYBACK_PAUSED}`, this.update, this);
    }
    /**
     * Click event handler.
     */
    onClick() {
        if (this.maapInstance.time.isPlaying) {
            this.maapInstance.time.pause();
        }
        else {
            this.maapInstance.time.play();
        }
    }
    /**
     * Update the container's DOM element according to the playing state.
     */
    update() {
        if (!this._container)
            return;
        if (this.maapInstance.time.isPlaying) {
            L.DomUtil.addClass(this._container, 'is-playing');
        }
        else {
            L.DomUtil.removeClass(this._container, 'is-playing');
        }
    }
}
//# sourceMappingURL=ControlPlayback.js.map